import { Feature } from '@tencent/workbench';
import type { NumberInputFrom } from '@tencent/wb-ext-form';
import BaseDrawerEffectFeature from '@framework/workbench/common/feature/base-drawer-effect-feature';
import { EffectPropsField } from '@editor/src/js/constants';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IReflectionModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { IReflectionFeature } from '@tencent/drawing-drawer-components';

const defaultReflectionProps = {
    startOpacity: 0,
    endOpacity: 99.7,
    size: 0,
    blurRad: 0,
    dist: 0,
    sy: -1,
    dir: 90,
    rotWithShape: 0,
};

@Feature()
export class ReflectionFeature extends BaseDrawerEffectFeature implements IReflectionFeature {
    public reflectionProps: IReflectionModelVal = { ...defaultReflectionProps };
    public get reflectionInfo() {
        return (this.getSelectModel() as IMultiplyModel | IElementBaseModel)?.getEffect?.()
            .getReflection() ?? defaultReflectionProps;
    }
    public get size() {
        return this.reflectionProps?.size;
    }
    public get blur() {
        return this.reflectionProps?.blurRad;
    }
    public get dist() {
        return this.reflectionProps?.dist;
    }
    public get opacity() {
        return Math.round(this.reflectionProps?.[EffectPropsField.STARTOPACITY.name]);
    }

    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.REFLECTION);
    }

    public initPropsCallback = () => {
        this.reflectionProps = { ...this.reflectionInfo };
    };

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.REFLECTION)
    public handleReflectionChange(value, dragEnd?: boolean, from?: NumberInputFrom) {
        const reflectionObj = this.getValidValue(value, from);
        this.reflectionProps = { ...this.reflectionInfo, ...reflectionObj };
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.updateReflectionProps(onlyChangeUI);
        this.handleReflectionReport(reflectionObj, from, onlyChangeUI);
    }

    public handleSelectColorChange = () => {
    };

    public updateReflectionProps = (onlyChangeUI?: boolean, onPreview?: boolean) => {
        if (this.checkSelectType() <= 1) {
            this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(false);
        }
        (this.getSelectModel() as IMultiplyModel | IElementBaseModel)?.getEffect?.()
            .updateReflection({ ...this.reflectionProps }, !!onlyChangeUI);
    };

    private handleReflectionReport = (value, from?: NumberInputFrom, onlyChangeUI?: boolean) => {
        let reportId;
        let ver6;
        if (value?.size) {
            reportId  = FormItemName.REFLECTION_SIZE;
            ver6 = value.size;
        }
        if (value?.blurRad) {
            reportId  = FormItemName.REFLECTION_BLUR;
            ver6 = value.blurRad;
        }
        if (value?.dist) {
            reportId  = FormItemName.REFLECTION_DISTANCE;
            ver6 = value.dist;
        }
        if (value?.[EffectPropsField.STARTOPACITY.name]) {
            reportId  = FormItemName.REFLECTION_OPICITY;
            ver6 = value?.[EffectPropsField.STARTOPACITY.name];
        }
        this.tdwDrawerReportNumberInput(reportId, { ver6 }, from, onlyChangeUI);
    };
}
